import React from 'react';
import { useSelector } from 'react-redux';

const Error = (props) => {
    const error = useSelector(state => state.redirect.error);
    console.log("Error : " + error);
    return (
        <div className='internal server-error'>

            <div className="internal server-error-title">
                <h2>500</h2>
                <p>Sorry, Unexpected error.</p>
                <p>Please contact to administrator or try again.</p>
                {
                    //<p>&#58;&#40;</p>
                    //<p><a href="/">Let me try again!</a></p>
                    //There is some issue while send email. Please try again.
                }
            </div>
        </div>
    )
};

export default Error;